import { useState, useEffect } from 'react';
import * as api from './api';

export const useStripeSetupIntent = () => {
  const [intent, setIntent] = useState(false);
  const [key, setKey] = useState(0); // used to reload intent

  useEffect(() => {
    (async () => {
      const itt = await api.post('/setup_intents');
      try {
        setIntent(itt.intent.client_secret);
      } catch (e) {
        console.error(
          `couldn't get stripe intent. Received : ${JSON.stringify(itt)}`,
        );
      }
    })();
  }, [key]);

  const reloadIntent = () => setKey(key + 1);

  return [intent, reloadIntent];
};

export const useStripePaymentIntent = ({
  client_id,
  amount,
  savePaymentMethod,
  ...props
}) => {
  const [intent, setIntent] = useState(false);
  // Valeur de savePaymentMethod avec laquelle `intent` a ete cree : permet a
  // l'appelant de refuser une confirmation sur un intent perime.
  const [intentSave, setIntentSave] = useState(savePaymentMethod);
  const [key, setKey] = useState(0); // used to reload intent

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const params = { client_id, amount };
      if (props.course_id) {
        params.course_id = props.course_id;
      }
      // Only send the contract field when the caller opts in. Omitting it
      // preserves the backward-compatible "save" default on the api side.
      if (typeof savePaymentMethod !== 'undefined') {
        params.save_payment_method = savePaymentMethod;
      }
      let itt;
      try {
        itt = await api.post('/payment_intents', params);
      } catch (e) {
        // intentSave reste perime : l'appelant refuse de confirmer et relance
        // la creation via reloadIntent() au prochain essai.
        console.error("couldn't create stripe intent", e);
        return;
      }
      // Reponse perimee (la case a change entre-temps) : on l'ignore, sinon un
      // intent cree avec l'ancienne valeur ecraserait le bon.
      if (cancelled) return;
      try {
        setIntent(itt.intent.client_secret);
        setIntentSave(savePaymentMethod);
      } catch (e) {
        console.log(e);
        console.error(
          `couldn't get stripe intent. Received : ${JSON.stringify(itt)}`,
        );
      }
    })();
    return () => {
      cancelled = true;
    };
    // savePaymentMethod is a dep so toggling the checkbox re-creates the
    // PaymentIntent with the correct setup_future_usage gating.
  }, [key, savePaymentMethod]);

  const reloadIntent = () => setKey(key + 1);

  return [intent, reloadIntent, intentSave];
};

// Hook for PaymentIntent with manual capture (Option A - pre-authorization)
export const useStripePaymentIntentManualCapture = ({
  client_id,
  amount,
  ...props
}) => {
  const [intent, setIntent] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    (async () => {
      const params = {
        client_id,
        amount,
        capture_method: 'manual',
      };
      if (props.course_id) {
        params.course_id = props.course_id;
      }
      const itt = await api.post('/payment_intents', params);
      try {
        setIntent(itt.intent.client_secret);
      } catch (e) {
        console.log(e);
        console.error(
          `couldn't get stripe payment intent (manual capture). Received : ${JSON.stringify(
            itt,
          )}`,
        );
      }
    })();
  }, [key, client_id, amount]);

  const reloadIntent = () => setKey(key + 1);

  return [intent, reloadIntent];
};
